import { render, staticRenderFns } from "./ContentPreview.vue?vue&type=template&id=132c9484"
import script from "./ContentPreview.vue?vue&type=script&lang=js"
export * from "./ContentPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports